<h2 mat-dialog-title>
    Previously Used ICD-10 Codes
    <span class="subtitle">{{ patientName }}</span>
</h2>

<mat-dialog-content class="archive-dialog-content">

    <!-- Says what this list IS. Without it a clinician reading a set of ICD-10 codes on a patient
         screen has every reason to read them as current coding, which is the opposite of the
         truth here. -->
    <p class="lead">
        Codes that have been removed from this patient's record. They are kept rather than deleted,
        so the coding history stays complete - <strong>none of these are on the record
        now</strong>.
    </p>

    <p class="hint" *ngIf="codes.length === 0">
        Nothing has been removed from this patient's coding.
    </p>

    <div class="archived-list">
        <div class="archived-code" *ngFor="let code of codes">

            <div class="code-line">
                <span class="code">{{ code.code }}</span>
                <span class="description" *ngIf="code.description">{{ code.description }}</span>
                <!-- A removed code that reached the switching house is the case this whole trail
                     exists for: the claim still references it. -->
                <span class="claimed" *ngIf="code.connectSubmissionStatus"
                    matTooltip="This code had already been submitted to the switching house when it was removed">
                    <mat-icon>receipt_long</mat-icon>submitted
                </span>
                <span class="pmb" *ngIf="code.pmbCodes"
                    matTooltip="PMB-linked — this code carried funding consequences">
                    <mat-icon>shield</mat-icon>PMB
                </span>
            </div>

            <div class="meta-line">
                <span class="meta" [class.unset]="!onsetLabel(code)">
                    {{ onsetLabel(code) ? 'Onset ' + onsetLabel(code) : 'no onset date' }}
                </span>
                <span class="meta" *ngIf="roleLabel(code)">{{ roleLabel(code) }}</span>
                <span class="meta" *ngIf="sourceLabel(code)">{{ sourceLabel(code) }}</span>
            </div>

            <div class="removal-line">
                <span *ngIf="code.removedAt">Removed {{ code.removedAt | date:'d MMM y' }}</span>
                <!-- A real state, not a rendering gap. The audit write is deliberately
                     non-throwing so it can never block a clinical write, so a removed code with no
                     recorded removal is possible — and saying so is better than an invented date. -->
                <span class="unrecorded" *ngIf="!code.removedAt">Removal not recorded</span>
                <span *ngIf="removedByLabel(code)">by {{ removedByLabel(code) }}</span>
            </div>

            <p class="reason" *ngIf="code.removedReason">&ldquo;{{ code.removedReason }}&rdquo;</p>

            <p class="superseded" *ngIf="code.supersededBy">
                Replaced by <strong>{{ code.supersededBy.code }}</strong>
                <span *ngIf="code.supersededBy.description"> - {{ code.supersededBy.description }}</span>
            </p>

        </div>
    </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="close()">Close</button>
</mat-dialog-actions>
